import * as React from "react"
import Layout from "../components/layout"
import OpeningHours from "../components/openinghours";
import ColoredLine from "../components/coloredline"
import { Link } from "gatsby"
import { StaticImage } from 'gatsby-plugin-image'
import { Carousel, Container, Card, Row, Col, Button, } from 'react-bootstrap';


const IndexPage = () => {

  return (

    <Layout pageTitle="DER OPTIKER zielinski">

      <Container fluid className="hertop">

        <Carousel>
          <Carousel.Item>

            <StaticImage
              className="d-block w-100"
              alt="Außenansicht von der optiker zielinski"
              src="../images/main1.jpg"
            />
            <Carousel.Caption>
              <h3>willkommen!</h3>
              <p>wir schärfen ihre blicke</p>
            </Carousel.Caption>
          </Carousel.Item>


          <Carousel.Item>

            <StaticImage
              className="d-block w-100"
              alt="brillen bei der optiker zielinski"
              src="../images/main2.jpg"
            />
            <Carousel.Caption>
              <h3>individuelle Beratung</h3>
              <p>alles was sie für die richtige brille brauchen</p>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>

            <StaticImage
              className="d-block w-100"
              alt="Außenansicht des Refraktionsraumes"
              src="../images/main3.jpg"
            />
            <Carousel.Caption>
              <h3>gute erreichbarkeit</h3>
              <p>sowohl mit den öffis als auch mit dem Auto</p>
            </Carousel.Caption>
          </Carousel.Item>

        </Carousel>

        <br></br>

        <Container>



          <h2 className="text-center"> aktuelle Öffnungszeiten </h2>


          <OpeningHours />


          <ColoredLine />

          <h2 className="text-center"> wie können wir helfen? </h2>

          <br></br>

          <Row>
            <Col xs={12} md={6} lg={6}>

              <Card className="text-center">
                <StaticImage
                  className="d-block w-100"
                  alt="Entdecken Sie alle brillenangebote von der optiker zielinski"
                  src="../images/brillen_category.jpeg"
                />
                <Card.Body>
                  <Card.Title>brillen</Card.Title>
                  <Card.Text className="text-justify">
                    Hier geht es zu unseren Angeboten für Brillen.
                  </Card.Text>

                  <Link className="btn btn-primary" role="button" to="/brillen">Zu Brillen</Link>

                </Card.Body>
              </Card>

              <br />

            </Col>


            <Col xs={12} md={6} lg={6}>

              <Card className="text-center">
                <StaticImage
                  className="d-block w-100"
                  alt="Entdecken Sie alle kontaktlinsen angebote von der optiker zielinski"
                  src="../images/kontaktlinsen_category.jpeg"
                />
                <Card.Body>
                  <Card.Title>kontaktlinsen</Card.Title>
                  <Card.Text className="text-justify">
                    Hier geht es zu unseren Angeboten für Kontaktlinsen.
                  </Card.Text>

                  <Link className="btn btn-primary" role="button" to="/kontaktlinsen">Zu Kontaktlinsen</Link>

                </Card.Body>
              </Card>

              <br />

            </Col>



            <Col xs={12} md={6} lg={6}>

              <Card className="text-center">
                <StaticImage
                  className="d-block w-100"
                  alt="Infos zur Adresse und Anfahrt zu der optiker zielinski"
                  src="../images/main3.jpg"
                />
                <Card.Body>
                  <Card.Title>anfahrt/kontakt</Card.Title>
                  <Card.Text className="text-justify">
                    Finden Sie Wegbeschreibungen mit dem Auto und den Öffis.
                  </Card.Text>

                  <Link className="btn btn-primary" role="button" to="/anfahrt">Zur Anfahrtsinformation</Link>

                </Card.Body>
              </Card>
              <br />

            </Col>


            <Col xs={12} md={6} lg={6}>

              <Card className="text-center">
                <StaticImage
                  className="d-block w-100"
                  alt="Infos zu Team und Geschichte von der optiker zielinski"
                  src="../images/main1.jpg"
                />

                <Card.Body>
                  <Card.Title>über uns</Card.Title>
                  <Card.Text className="text-justify">
                    Erfahren Sie mehr über uns und unsere Geschichte.
                  </Card.Text>

                  <Link className="btn btn-primary" role="button" to="/about">Mehr zu uns</Link>

                </Card.Body>
              </Card>
              <br />

            </Col>



          </Row>

          <ColoredLine />


          <div className="text-center">

            <h2>finden Sie uns auf Facebook</h2>

            <p>Einfach "deroptikerzielinski" in facebook suchen folgen. Neben aktuellen News und Bildern aus dem Shop verlost DER OPTIKER auch hin und wieder Interessante Sachpreise unter seinen facebook Freunden.</p>

            <Button variant="primary">

              <a href="https://www.facebook.com/deroptikerzielinski" target="_blank" rel="noopener noreferrer">
                Zur Facebookseite von deroptiker zielinski
              </a>
            </Button>

            <ColoredLine/>

            <h2>ihnen hat der Besuch bei uns gefallen?</h2>

            <p>Schreiben Sie uns gerne Ihre Bewertung oder Feedback auf Google Maps.</p>

            <Button variant="primary">

              <a href="https://g.page/r/CRIBMnqxKhdmEAg/review" target="_blank" rel="noopener noreferrer">
                Bewerten 
                </a>
            </Button>

          </div>

          <br></br>

        </Container>

      </Container>

    </Layout>

  )

}

export default IndexPage